const body = document.querySelector('body');
const modalTrigger = document.querySelectorAll('[data-modal-element="trigger"]');
const modalCloser = document.querySelectorAll('[data-modal-element="closer"]');
const toggleModal = (modalName) => {
    body.classList.toggle('modal-open');
    body.classList.toggle('modal-open--' + modalName);
};
modalTrigger.forEach((trigger) => {
    trigger.onclick = () => {
        const modalTarget = trigger.getAttribute('data-modal-target');
        if (modalTarget) {
            toggleModal(modalTarget);
        }
    };
});
modalCloser.forEach((closer) => {
    closer.onclick = () => {
        const modalTarget = closer.getAttribute('data-modal-target');
        if (modalTarget) {
            toggleModal(modalTarget);
        }
    };
});
